


























































































































































import {Component, Vue, Watch} from 'vue-property-decorator';
	import { AxiosStatic } from 'axios';
	import IResource from "@/interfaces/IResource";

	@Component
	export default class Embed extends Vue {

		public selectedResource: number | string = 0;

		private $http!: AxiosStatic;

		get resourceId(): number {
			return parseInt((<any>this.$route.params).id || 0);
		}

		get resource(): IResource | null {
			if (this.$store.state.resources) {
				let filtered = this.$store.state.resources.filter((r: IResource) => r.id == this.resourceId);
				if (filtered.length > 0) {
					return filtered[0];
				}
			}
			return null;
		}

		get resources(): IResource[] {
			return this.$store.state.resources;
		}

		get singledayResources(): IResource[] {
			return this.$store.getters.singledayResources;
		}

		get hasMixedResources(): boolean {
			return this.$store.getters.singledayResources.length > 0 && this.$store.getters.multidayResources.length > 0;
		}

		get calendarUrl(): string {
			if (this.selectedResource) {
				if (this.selectedResource === 'org' && this.$store.state.organisation) {
					return location.origin + '/org/' + this.$store.state.organisation.multicalendar_hash + '/' + (this.$store.state.organisation.name || 'reservation').replace(/[\W\s]+/g, '-').replace(/--/g, '-');
				}
				let resource = this.resources.filter(res => res.id === this.selectedResource);
				if (resource.length > 0) {
					return location.origin + '/reservation/' + resource[0].reservationhash + '/' + resource[0].name.replace(/[\W\s]+/g, '-').replace(/--/g, '-');
				}
			}
			return '';
		}

		get icalBaseUrl(): string {
			return location.origin + '/ical/';
		}

		@Watch('resourceId', { immediate: true })
		public watchId() {
			this.selectedResource = this.resourceId;
		}

		public async mounted(): Promise<void> {
			this.$store.dispatch('loadResources', {root: true});
		}
	}
